import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BaseModalContainer, ModalContainerService, ModalService, UserService } from 'yt-ng-framework';
import { VrstaIzostanka } from './vrsta-izostanka';

@Component({
  selector: 'app-vrsta-izostanka',
  templateUrl: './vrsta-izostanka.component.html'
})
export class VrstaIzostankaComponent extends BaseModalContainer<VrstaIzostanka> implements OnInit {
  
  constructor(
    protected modalContainerService: ModalContainerService<VrstaIzostanka>,
    protected activatedRoute: ActivatedRoute,
    protected modalService: ModalService,
    protected userService: UserService
  ) { 
    super(modalContainerService, activatedRoute, modalService,userService)
  }

  ngOnInit() {
  }

}
